import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MessageSquare, Send, X, Loader2, Sparkles } from "lucide-react";

export function AiAssistant() {
  const [open, setOpen] = useState(false);
  const [question, setQuestion] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const ask = async () => {
    if (!question.trim() || loading) return;
    const q = question;
    setQuestion("");
    setMessages(prev => [...prev, { role: "user", text: q }]);
    setLoading(true);
    try {
      const res = await api.post("/ai/ask", { question: q });
      setMessages(prev => [...prev, { role: "ai", text: res.data.answer }]);
    } catch (e) {
      setMessages(prev => [...prev, { role: "ai", text: "Przepraszam, nie mogę teraz odpowiedzieć. Spróbuj ponownie." }]);
    }
    setLoading(false);
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="h-10 px-4 rounded-full bg-gradient-to-r from-[#0A1C3A] to-[#1a3a5c] text-white shadow hover:shadow-lg flex items-center gap-2 transition-all hover:scale-105 text-sm"
        title="AI Asystent"
      >
        <Sparkles className="h-4 w-4" />
        <span className="hidden md:inline">AI Asystent</span>
      </button>
    );
  }

  return (
    <div className="fixed top-16 right-6 z-50 w-96 bg-white rounded-2xl shadow-2xl border flex flex-col" style={{ maxHeight: "500px" }}>
      <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-[#0A1C3A] to-[#1a3a5c] text-white rounded-t-2xl">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4" />
          <span className="font-medium text-sm">AI Asystent CRM</span>
        </div>
        <button onClick={() => setOpen(false)} className="hover:bg-white/20 rounded-full p-1"><X className="h-4 w-4" /></button>
      </div>
      
      <div className="flex-1 overflow-y-auto p-3 space-y-3" style={{ maxHeight: "350px" }}>
        {messages.length === 0 && (
          <div className="text-center py-6 text-slate-400 text-sm">
            <Sparkles className="h-8 w-8 mx-auto mb-2 opacity-50" />
            Zapytaj o cokolwiek z CRM:<br />
            "Kto ma zaległe zadania?"<br />
            "Ilu mamy aktywnych klientów?"
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[85%] px-3 py-2 rounded-2xl text-sm ${
              m.role === "user" ? "bg-[#0A1C3A] text-white rounded-br-md" : "bg-slate-100 text-slate-800 rounded-bl-md"
            }`}>
              {m.text}
            </div>
          </div>
        ))}
        {loading && (
          <div className="flex justify-start">
            <div className="bg-slate-100 rounded-2xl px-4 py-2 rounded-bl-md">
              <Loader2 className="h-4 w-4 animate-spin text-slate-400" />
            </div>
          </div>
        )}
      </div>
      
      <div className="border-t p-3 flex gap-2">
        <Input
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="Zadaj pytanie..."
          className="text-sm h-9"
          onKeyDown={(e) => e.key === "Enter" && ask()}
        />
        <Button size="sm" className="h-9 px-3 bg-[#0A1C3A]" onClick={ask} disabled={loading || !question.trim()}>
          <Send className="h-3 w-3" />
        </Button>
      </div>
    </div>
  );
}
